export const iconsprite = `
<svg xmlns="http://www.w3.org/2000/svg" style="display:none">
  <defs>
    <symbol id="icon-clock" viewBox="0 0 24 24">
          <path
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
          />
          <path d="M12 7.19922V11.9992L15.2 13.5992" />
        </symbol>
        <symbol id="icon-filter" viewBox="0 0 24 24">
          <path
            d="M3.963,10.352c0,1.776,1.439,3.215,3.215,3.215s3.215-1.439,3.215-3.215-1.439-3.215-3.215-3.215-3.215,1.439-3.215,3.215Z"
          />
          <path d="M7.178,3.963v3.179" />
          <path d="M7.178,13.607v6.43" />
          <path
            d="M13.607,13.648c0-1.776,1.439-3.215,3.215-3.215s3.215,1.439,3.215,3.215-1.439,3.215-3.215,3.215h0c-1.776,0-3.215-1.439-3.215-3.215Z"
          />
          <path d="M16.822,20.037v-3.179" />
          <path d="M16.822,10.393V3.963" />
        </symbol>
        <symbol id="icon-arrow-down" viewBox="0 0 24 24">
          <polyline points="5.912 8.936 12.041 15.064 18.088 9.017" />
        </symbol>
        <symbol id="icon-arrow-right" viewBox="0 0 24 24">
          <polyline points="8.936 18.088 15.064 11.959 9.017 5.912" />
        </symbol>
        <symbol id="icon-arrow-top" viewBox="0 0 24 24">
          <polyline points="18.088 15.064 11.959 8.936 5.912 14.983" />
        </symbol>
        <symbol id="icon-back" viewBox="0 0 24 24">
          <polyline points="15.064 5.912 8.936 12.041 14.983 18.088" />
        </symbol>
        <symbol id="icon-itinerary" viewBox="0 0 24 24">
          <path d="M14.662,13.775l4.436-4.436-4.436-4.436" />
          <path
            d="M4.902,19.098v-6.211c0-.941.374-1.844,1.04-2.51.666-.666,1.568-1.04,2.51-1.04h10.648"
          />
        </symbol>
        <symbol id="icon-long-arrow-left" viewBox="0 0 24 24">
          <path d="M19 12H5" />
          <path d="M12 19L5 12L12 5" />
        </symbol>
        <symbol id="icon-long-arrow-right" viewBox="0 0 24 24">
          <path d="M5 12H19" />
          <path d="M12 5L19 12L12 19" />
        </symbol>
        <symbol id="icon-close" viewBox="0 0 24 24">
          <path d="M18 6L6 18" />
          <path d="M6 6L18 18" />
        </symbol>
        <symbol id="icon-minus" viewBox="0 0 24 24">
          <path d="M5 12H19" />
        </symbol>
        <symbol id="icon-plus" viewBox="0 0 24 24">
          <line x1="12" y1="4.937" x2="12" y2="19.063" />
          <line x1="4.937" y1="12" x2="19.063" y2="12" />
        </symbol>
        <symbol id="icon-search" viewBox="0 0 24 24">
          <circle cx="11.324" cy="11.447" r="7.487" />
          <line x1="16.645" y1="16.71" x2="20.758" y2="20.823" />
        </symbol>
        <symbol id="icon-location" viewBox="0 0 24 24">
          <path
            d="M12,20.196c4.526,0,8.196-3.669,8.196-8.196S16.526,3.804,12,3.804,3.804,7.474,3.804,12s3.669,8.196,8.196,8.196Z"
          />
          <path d="M20.196,12h-3.278" />
          <path d="M7.083,12h-3.278" />
          <path d="M12,7.083v-3.278" />
          <path d="M12,20.196v-3.278" />
        </symbol>
        <symbol id="icon-switch" viewBox="0 0 24 24">
          <line x1="7.714" y1="8.752" x2="7.714" y2="18.509" />
          <polyline points="11.784 14.44 7.714 18.509 3.644 14.44" />
          <line x1="16.286" y1="15.248" x2="16.286" y2="5.491" />
          <polyline points="12.216 9.56 16.286 5.491 20.356 9.56" />
        </symbol>
        <symbol id="icon-itinerary-custom" viewBox="0 0 24 24">
          <rect
            x="4.922"
            y="4.922"
            width="14.156"
            height="14.156"
            rx="1.536"
            ry="1.536"
            transform="translate(-4.971 12) rotate(-45)"
          />
          <path d="M12.598,14.512l2.791-2.791-2.791-2.791" />
          <path d="M6.457,16.467v-2.513c0-1.233,1-2.233,2.233-2.233h6.699" />
        </symbol>
        <symbol id="icon-calendar" viewBox="0 0 24 24">
          <rect
            x="3.591"
            y="4.523"
            width="16.819"
            height="16.819"
            rx="1.943"
            ry="1.943"
          />
          <line x1="3.591" y1="10.177" x2="20.409" y2="10.177" />
          <line x1="8.246" y1="2.658" x2="8.246" y2="6.428" />
          <line x1="15.712" y1="2.658" x2="15.712" y2="6.428" />
        </symbol>
        <symbol id="icon-origin" viewBox="0 0 24 24">
          <path
            d="M17.261,6.37c-2.944-2.802-7.576-2.802-10.52,0-3.145,2.994-2.976,8.088.094,11.158l.101.101c2.803,2.803,7.327,2.803,10.115.015l.094-.094c3.092-3.092,3.261-8.186.116-11.18Z"
          />
          <circle cx="12" cy="12" r="2.631" />
        </symbol>
        <symbol id="icon-destination" viewBox="0 0 24 24">
          <path
            d="M12,3.882h0c3.994,0,7.236,3.242,7.236,7.236h0c0,3.994-3.242,7.236-7.236,7.236h-6.16c-.594,0-1.076-.482-1.076-1.076v-6.16c0-3.994,3.242-7.236,7.236-7.236Z"
            transform="translate(-4.347 11.742) rotate(-45)"
          />
          <circle cx="12" cy="11.118" r="2.631" />
        </symbol>
        <symbol id="icon-fuel" viewBox="0 0 24 24">
          <path
            d="M5.641,5.943h7.991c.21,0,.38.17.38.38v15.406H5.262V6.323c0-.21.17-.38.38-.38Z"
          />
          <line x1="7.398" y1="9.243" x2="11.861" y2="9.243" />
          <line x1="9.637" y1="11.658" x2="11.861" y2="11.658" />
          <path
            d="M14.012,16.694h2.836c1.044,0,1.891-.846,1.891-1.891V5.943l-3.672-3.672"
          />
          <path
            d="M18.738,9.939l-1.23-1.23c-.588-.588-.919-1.386-.919-2.218v-2.696"
          />
        </symbol>
        <symbol id="icon-car" viewBox="0 0 24 24">
          <path
            d="M21,8l-2,2M19,10l-1.5-3.7c-.142-.379-.394-.706-.725-.938s-.725-.358-1.129-.362h-7.246c-.407-.009-.808.106-1.148.331-.34.225-.603.548-.755.926l-1.497,3.743M19,10H5M19,10c1.105,0,2,.896,2,2v4c0,1.105-.895,2-2,2M5,10l-2-2M5,10c-1.105,0-2,.896-2,2v4c0,1.105.895,2,2,2M7,14h.01M17,14h.01M19,18H5M19,18v2M5,18v2"
          />
        </symbol>
        <symbol id="icon-bus" viewBox="0 0 24 24">
          <path
            d="M4,6l-2,1M10,6h4M22,7l-2-1M18,19c1.105,0,2-.895,2-2V5c0-1.105-.895-2-2-2H6c-1.105,0-2,.895-2,2v12c0,1.105.895,2,2,2M18,19H6M18,19v2M6,19v2M4,11h16M8,15h.01M16,15h.01"
          />
        </symbol>
        <symbol id="icon-bike" viewBox="0 0 24 24">
          <path
            d="M12,17.078v-3.555l-3.108-3.047,4.144-3.047,2.072,3.047h2.072M22.36,17.078c0,1.963-1.623,3.555-3.626,3.555s-3.626-1.591-3.626-3.555,1.623-3.555,3.626-3.555,3.626,1.592,3.626,3.555ZM8.892,17.078c0,1.963-1.623,3.555-3.626,3.555s-3.626-1.591-3.626-3.555,1.623-3.555,3.626-3.555,3.626,1.592,3.626,3.555ZM16.144,4.383c0,.561-.464,1.016-1.036,1.016s-1.036-.455-1.036-1.016.464-1.016,1.036-1.016,1.036.455,1.036,1.016Z"
          />
        </symbol>
        <symbol id="icon-walk" viewBox="0 0 24 24">
          <line x1="12.348" y1="8.127" x2="6.53" y2="21" />
          <polyline points="10.367 12.459 14.452 15.554 14.452 21" />
          <path
            d="M4.055,10.974c2.476-2.352,6.56-4.332,8.293-2.971s3.342,4.58,7.798,4.332"
          />
          <circle cx="14.452" cy="4.414" r="1.114" />
        </symbol>
        <symbol id="icon-info" viewBox="0 0 24 24">
          <path
            d="M12,3.444C7.275,3.444,3.444,7.275,3.444,12s3.831,8.556,8.556,8.556,8.556-3.831,8.556-8.556S16.725,3.444,12,3.444Z"
          />
          <path d="M12,8.578h-.009" />
          <path d="M12,15.422v-3.422" />
        </symbol>
        <symbol id="icon-eye" viewBox="0 0 24 24">
          <path
            d="M2.383,12s3.497-6.994,9.617-6.994,9.617,6.994,9.617,6.994c0,0-3.497,6.994-9.617,6.994S2.383,12,2.383,12Z"
          />
          <path
            d="M12,14.623c1.449,0,2.623-1.174,2.623-2.623s-1.174-2.623-2.623-2.623-2.623,1.174-2.623,2.623,1.174,2.623,2.623,2.623Z"
          />
        </symbol>
        </defs> 
    </svg>`;
